import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useWebSocket from "react-use-websocket";
import { Box, Container, Theme } from "@mui/material";
import DesktopView from "src/components/MicroFrontend/DesktopView";
import MobileView from "src/components/MicroFrontend/MobileView";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";

const decodedStringBtoA = process.env.REACT_APP_LIVE_API_KEY ?? "";
const encodedStringBtoA = btoa(decodedStringBtoA);

const Demo = () => {
  const { uuid = "" } = useParams();
  const theme = useContext(ThemeContext);
  const [data, setData] = useState<any>();

  const [currentSocketUrl] = useState(
    `${process.env.REACT_APP_LIVE_API_URL}/${uuid}?authorization=${encodedStringBtoA}`
  );

  const { lastJsonMessage } = useWebSocket(currentSocketUrl, {
    share: false,
    shouldReconnect: () => false,
  });

  useEffect(() => {
    lastJsonMessage && setData(lastJsonMessage);
  }, [lastJsonMessage]);

  return (
    <Container disableGutters>
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <DesktopView uuid={uuid} data={data} theme={theme} />
      </Box>

      <Box
        sx={(theme: Theme) => ({
          display: { sm: "none" },
          background: theme.palette.white.main,
        })}
      >
        <MobileView uuid={uuid} data={data} theme={theme} />
      </Box>
    </Container>
  );
};

export default Demo;
